import React from "react";
import { Link } from "react-router-dom";

import { addDots } from "./../../helpers/addThreeDots";

import { Card, CardContent, Typography, Button } from "@material-ui/core";
import { Visibility } from "@material-ui/icons";

const AdditionalInformation = ({ data, dataKey, path, useUid = false }) => {
  return (
    <>
      {data.map((card) => (
        <Card key={card.id} className="additional-card">
          <CardContent className="content-card">
            <Typography variant="h6" component="h6">
              {addDots(card[dataKey])}
            </Typography>
            <Link to={`/${path}/${useUid ? card.uid : card.id}`} className="additional-link">
              <Button
                className="view-btn"
                variant="outlined"
                color="inherit"
                startIcon={<Visibility />}
              >
                View
              </Button>
            </Link>
          </CardContent>
        </Card>
      ))}
    </>
  );
};

export default AdditionalInformation;
